import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  catalog: [],
  variant: [],
  current: {},
  currentSelect: {},
};

export const changeModelSlice = createSlice({
  name: 'changeModel',
  initialState,
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload;
    },
    setCatalog: (state, action) => {
      state.catalog = action.payload;
    },
    setVariant: (state, action) => {
      state.variant = action.payload;
    },
    setCurrent: (state, action) => {
      state.current = action.payload;
    },
    setCurrentSelect: (state, action) => {
      state.currentSelect = action.payload;
    },
    clearChangeModel: (state, action) => {
      state.current = {};
    },
  },
});

export const { setOpen, setCatalog, setVariant, setCurrent, clearChangeModel, setCurrentSelect } =
  changeModelSlice.actions;

export default changeModelSlice.reducer;
